import { NavLink } from 'react-router-dom';
import { useSettings } from '@/settings/settingsStore';

export function Top({ sub }: { sub?: string }) {
  const s = useSettings();
  return (
    <header className="top">
      <div>
        <span className="name">{s.companionName || 'Puppy'}</span>
        {sub && <span className="sub">{sub}</span>}
      </div>
      <nav>
        <NavLink to="/" end className={({ isActive }) => (isActive ? 'on' : '')}>聊天</NavLink>
        <NavLink to="/memory" className={({ isActive }) => (isActive ? 'on' : '')}>它记得的</NavLink>
        <NavLink to="/settings" className={({ isActive }) => (isActive ? 'on' : '')}>设置</NavLink>
      </nav>
    </header>
  );
}
